import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AuthRoutingModule } from './auth-routing.module'
import { LoginComponent } from './components/login/login.component'
import { AuthContainerComponent } from './components/auth-container/auth-container.component'
import { ReactiveFormsModule } from '@angular/forms'
import { ValidatePinComponent } from './components/validate-pin/validate-pin.component'
import { ApplyResetComponent } from './components/apply-reset/apply-reset.component'
import { AuthHeaderComponent } from './components/auth-header/auth-header.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { OrgFinderComponent } from './components/org-finder/org-finder.component'
import { SamlCallbackComponent } from './components/saml-callback/saml-callback.component'

// Replace SharedModule with focused modules for better tree-shaking
import { CoreUIModule } from '@app/shared/core-ui.module'
import { CorePrimeNGModule } from '@app/shared/core-primeng.module'
import { FormsPrimeNGModule } from '@app/shared/forms-primeng.module'
import { YabiComponentsModule } from '@app/shared/yabi-components.module'
import { TranslateModule } from '@ngx-translate/core'
import { PasswordModule } from 'primeng/password'

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    AuthContainerComponent,
    ValidatePinComponent,
    ApplyResetComponent,
    AuthHeaderComponent,
    OrgFinderComponent,
    SamlCallbackComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,

    // Focused modules replacing SharedModule (saves ~400-500KB)
    CoreUIModule, // Basic UI components (row, cell, alert)
    CorePrimeNGModule, // Essential PrimeNG (button, input, dialog)
    FormsPrimeNGModule, // Form components (input styling)
    YabiComponentsModule, // Custom components (app-yabi-input)
    TranslateModule, // Translation support
    PasswordModule, // Specific PrimeNG component
  ],
  providers: [],
})
export class AuthModule {}
